<div class="pass-card-wrapper" style="cursor: pointer;">
    <div class="pass-badge">
        <fa-icon [icon]="faTicket"></fa-icon>
        <span>Abono</span>
    </div>
    <div class="pass-card-body">
        <div class="pass-name">{{ pass?.name }}</div>
        <div class="pass-events-count" *ngIf="pass?.pass_items?.length || pass?.passItems?.length">
            <i class="fal fa-calendar"></i>
            <span>{{ (pass.pass_items || pass.passItems).length }} evento{{ (pass.pass_items || pass.passItems).length > 1 ? 's' : '' }}</span>
        </div>
        <!-- Precio fijo: discount_value va a 0 y no significa nada; se pinta el «desde» -->
        <div class="pass-price" *ngIf="isFixedPrices()">{{ fixedPriceLabel() }}</div>
        <div class="pass-price" *ngIf="!isFixedPrices() && pass?.discount_value != null">
            {{ pass.discount_mode === 'percentage' ? pass.discount_value + '% dto.' : formatPrice(+pass.discount_value) }}
        </div>
    </div>
</div>
